const ETAPAS_CHECKLIST = [
  { campo: 'dt_contrato_assinado',            label: 'Contrato assinado' },
  { campo: 'dt_pagamento_realizado',          label: 'Pagamento realizado' },
  { campo: 'dt_procuracao_hipossuficiencia',  label: 'Procuração e hipossuficiência enviada' },
  { campo: 'dt_documentos_entregues',         label: 'Documentos entregues' },
  { campo: 'dt_notificacao_enviada',          label: 'Notificação enviada' },
  { campo: 'dt_acao_protocolada',             label: 'Ação protocolada' },
  { campo: 'dt_impugnacao',                   label: 'Impugnação' },
  { campo: 'dt_sentenca',                     label: 'Sentença' },
];

function fmtMoeda(v) {
  return (Number(v) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}
function fmtData(d) {
  return d ? new Date(d + 'T00:00').toLocaleDateString('pt-BR') : null;
}
function diasAtraso(dataStr) {
  if (!dataStr) return 0;
  const hojeStr = new Date().toISOString().split('T')[0];
  return Math.max(0, Math.floor((new Date(hojeStr) - new Date(dataStr)) / 86400000));
}

export default function PortalCasos({ casos, cobrancas, corProjeto }) {
  if (!casos.length) {
    return <div className="portal-estado">Nenhum caso registrado ainda para este projeto.</div>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      {casos.map(caso => {
        const concluidas = ETAPAS_CHECKLIST.filter(e => caso[e.campo]).length;
        const honTotal = (Number(caso.honorarios_exito) || 0) + (Number(caso.honorarios_sucumbencia) || 0);
        const cobsAtrasadas = (cobrancas || []).filter(c => c.caso_id === caso.id && c.status !== 'Recebido' && diasAtraso(c.data_prevista) > 0);
        const maxAtraso = cobsAtrasadas.reduce((max, c) => Math.max(max, diasAtraso(c.data_prevista)), 0);
        const temAtraso = cobsAtrasadas.length > 0;
        return (
          <div key={caso.id} className="card" style={{ padding: 18, borderLeft: `4px solid ${temAtraso ? '#dc2626' : (corProjeto || 'var(--purple)')}`, background: temAtraso ? '#fff8f8' : undefined }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8, flexWrap: 'wrap', gap: 8 }}>
              <div>
                <div style={{ fontWeight: 700, fontSize: 15, color: 'var(--text-primary)' }}>{caso.nome_cliente}</div>
                <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 2 }}>{caso.status || 'Em andamento'}</div>
                {temAtraso && (
                  <div style={{ background: '#fee2e2', color: '#dc2626', fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 20, display: 'inline-block', marginTop: 6 }}>
                    ⚠ Pagamento em atraso há {maxAtraso} dia{maxAtraso > 1 ? 's' : ''}
                  </div>
                )}
              </div>
              {caso.link_drive && (
                <a href={caso.link_drive} target="_blank" rel="noreferrer"
                  style={{ fontSize: 12, color: '#4A90D9', fontWeight: 600, textDecoration: 'none' }}>📁 Ver documentos</a>
              )}
            </div>

            {(caso.tipos_acao || []).length > 0 && (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 10 }}>
                {caso.tipos_acao.map(t => (
                  <span key={t} style={{ background: 'var(--bg-secondary)', color: 'var(--purple-rich)', fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 20 }}>{t}</span>
                ))}
              </div>
            )}

            {caso.resumo && (
              <div style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.6, marginBottom: 12, whiteSpace: 'pre-wrap' }}>{caso.resumo}</div>
            )}

            {(caso.valor_contrato || honTotal > 0) && (
              <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap', marginBottom: 12, fontSize: 12 }}>
                {caso.valor_contrato && <span>💰 Valor do contrato: <strong>{fmtMoeda(caso.valor_contrato)}</strong>{caso.n_parcelas ? ` em ${caso.n_parcelas}x` : ''}</span>}
                {honTotal > 0 && <span>Honorários totais: <strong>{fmtMoeda(honTotal)}</strong></span>}
              </div>
            )}

            <div style={{ marginTop: 6 }}>
              <div style={{ height: 4, background: 'var(--bg-secondary)', borderRadius: 4, marginBottom: 8 }}>
                <div style={{ width: `${(concluidas / ETAPAS_CHECKLIST.length) * 100}%`, height: '100%', background: 'linear-gradient(90deg, var(--purple-rich), var(--lilac))', borderRadius: 4 }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                {ETAPAS_CHECKLIST.map(e => (
                  <div key={e.campo} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12.5 }}>
                    <span style={{ color: caso[e.campo] ? '#16a34a' : 'var(--gray-300)' }}>{caso[e.campo] ? '✓' : '○'}</span>
                    <span style={{ color: caso[e.campo] ? 'var(--text-primary)' : 'var(--gray-400)', fontWeight: caso[e.campo] ? 600 : 400 }}>{e.label}</span>
                    {caso[e.campo] && <span style={{ color: 'var(--gray-400)', fontSize: 11 }}>{fmtData(caso[e.campo])}</span>}
                  </div>
                ))}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
